import { ODataObject } from '../../interfaces/odata-model.interface';
import { ConfigService } from '../../services/config/config.service';
import { CustomInjector } from '../../services/custom-injector/custom-injector';
import { ModelOptionsLoaderService } from '../../services/model-options-loader/model-options-loader.service';
import { ODataTextOutModel, TextModel } from '../primitive/text.model';
import { ArrayModel } from './array.model';
import { CompositeModel } from './composite.model';

const odataEmailAddressSet = 'EmailAddressSet';
const odataTextLine = 'TextLine';

export class ConfirmationAdditionalEmailsModel extends CompositeModel {
    public emailAddresses: ArrayModel<TextModel>;
    public modelOptionsLoader: ModelOptionsLoaderService;
    private readonly predefinedEmailDomain: string;
    public constructor() {
        super('ConfirmationAdditionalEmailsModel');

        const injector = CustomInjector.getInjector();
        const configService = injector.get(ConfigService);
        this.modelOptionsLoader = injector.get(ModelOptionsLoaderService);

        this.emailAddresses = <ArrayModel<TextModel>>this.set(new ArrayModel<TextModel>(odataEmailAddressSet));
        this.addEmail(configService.getCseEmailFax());

        this.predefinedEmailDomain = configService.getPredefinedEmailDomainName();
    }

    public addEmail(address = ''): void {
        // Backend is expecting TextLine, and the value of the textbox should be preset to @siemens-healthineers.com
        const newEmailAddress = new TextModel(odataTextLine, address ? address : this.predefinedEmailDomain);
        this.modelOptionsLoader.load(newEmailAddress, 'AdditionalEmails', 'EmailsField');
        newEmailAddress.options = {
            ...newEmailAddress.options,
            focusCursorPosition: 0,
        };
        this.emailAddresses.addModel(newEmailAddress);
    }

    public toJSON(): unknown {
        return {
            emailAddresses: this.emailAddresses.value.map((entry) => entry.value),
        };
    }
}

export class ConfirmationAdditionalEmailsModelFromJson extends ConfirmationAdditionalEmailsModel {
    public constructor(data: JsonConfirmationAdditionalEmailsModel) {
        super();

        // remove the CSE mail address, otherwise it will be in the array twice
        this.emailAddresses.removeModel(0);

        // now add all stored addresses, including the CSE mail address
        data.emailAddresses.forEach((address) => this.addEmail(address));
    }
}

export interface JsonConfirmationAdditionalEmailsModel {
    emailAddresses: string[];
}

export interface ODataConfirmationAdditionalEmailsModelOutModel extends ODataObject {
    EmailAddressSet: ODataTextOutModel[];
}
